import { InspectorControls, PanelColorSettings } from "@wordpress/block-editor";

import {
    PanelBody,
    ToggleControl,
    __experimentalView as View,
} from "@wordpress/components";

import UnitRange from "./components/UnitRange";
import BorderRange from "./components/BorderRange";

const { addFilter } = wp.hooks;

const detailsExtension = (settings, name) => {
    if (name !== "core/details") {
        return settings;
    }
    // Zachowaj istniejące atrybuty
    const existingAttributes = settings.attributes || {};

    return {
        ...settings,
        attributes: {
            ...existingAttributes,
            hasCustomMarker: {
                type: `boolean`,
                default: false,
            },
            hasBoldSummary: {
                type: `boolean`,
                default: false,
            }
        },
    };
};

const detailsExtensionEdit = wp.compose.createHigherOrderComponent(
    (BlockEdit) => {
        return (props) => {
            if (props.name !== "core/details") {
                return <BlockEdit {...props} />;
            }

            const { attributes, setAttributes, clientId, wrapperProps } = props;

            return (
                <>
                    <div className={`${!attributes.hasCustomMarker || 'has-custom-marker'} ${!attributes.hasBoldSummary || 'has-bold-summary'}`}>
                        <BlockEdit {...props} />
                    </div>
                    <InspectorControls>
                        <PanelBody title="Details block settings" initialOpen={true}>
                            <View style={{ padding: "5px 0 15px 0" }}>
                                <ToggleControl
                                    label="Zamień strzałkę na plusa"
                                    checked={attributes.hasCustomMarker}
                                    onChange={(value) =>
                                        setAttributes({
                                            hasCustomMarker: value,
                                        })
                                    }
                                    __nextHasNoMarginBottom={true}
                                />                                
                                <ToggleControl
                                    label="Pogrubienie tekstu podsumowania"
                                    checked={attributes.hasBoldSummary}
                                    onChange={(value) =>
                                        setAttributes({
                                            hasBoldSummary: value,
                                        })
                                    }
                                    __nextHasNoMarginBottom={true}
                                />
                            </View>
                        </PanelBody>
                    </InspectorControls>
                </>
            );
        };
    },
    "withButtonHoverControls"
);

const detailsExtensionProps = (extraProps, blockType, attributes) => {
    if (blockType.name !== "core/details") {
        return extraProps;
    }

    return {
        ...extraProps,
        className: `${extraProps.className ? extraProps.className : ``} ${attributes.hasCustomMarker ? "has-custom-marker" : ""} ${!attributes.hasBoldSummary || 'has-bold-summary'}`,
    };
};

addFilter(
    "blocks.registerBlockType",
    "danone/details-extension",
    detailsExtension
);

addFilter(
    "editor.BlockEdit",
    "danone/details-extension-edit",
    detailsExtensionEdit
);

addFilter(
    "blocks.getSaveContent.extraProps",
    "danone/details-extension-props",
    detailsExtensionProps
);
